<div class="layout-container">
    <app-navbar></app-navbar>
    <div class="main-content">
        <app-sidebar></app-sidebar>
        <main class="content-area">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>
